module.exports = __webpack_public_path__ + "img/about_mamadays_shop.a84f2e64.png";